export default function Avatar({ user, size = "md", className = "" }) {
  const dimensions = {
    sm: "h-7 w-7",
    md: "h-9 w-9",
    lg: "h-11 w-11",
  }
  const label = user?.username ? `${user.username}'s profile picture` : "Profile picture"

  return (
    <img
      src={user?.avatar_url}
      alt={label}
      className={`${dimensions[size] || dimensions.md} shrink-0 rounded-full bg-stone-800 ring-1 ring-stone-700/80 ${className}`}
      loading="lazy"
      referrerPolicy="no-referrer"
    />
  )
}
